import './valueseries.html';

import moment from 'moment';

import { CommonViewController, CONSOLIDATION_CURRENCY_PARAMS } from '../../controller/CommonViewController';
import { DEF_CURRENCY, CONSOLIDATION_CURRENCY } from '../dashboard/dashboard';
import { AXIS_DEFAULT_COLOR, ChartUtil } from '../../utils/chart/ChartUtil';
import { FlotService, BAR_TIME_SHIFT } from '../../services/FlotService';
import { CurrencyService } from '../../services/CurrencyService';
import { VALUES_CHART, VALUE_SERIES } from '../../services/arsweb/RoutingPaths';
import { BackendService } from '../../services/BackendService';
import { TAB_GROUP, TAB_BANK, TAB_COUNTRY, TAB_CURRENCY, TAB_OVERVIEW, TAB_ACCOUNT } from '../accounts/overview';
import { keyLanguage } from 'fides-angularjs-components/src/fts-services/fts-user-service';
import { REPORT_TYPE } from "../../components/report/ReportModalController";
import { EXPORT_TYPE } from "../../components/export/ExportModalController";

export const VALUESERIES_ROUTE = 'app.valueseries';
export const VALUESERIES_TITLE = 'VALUE_SERIES';

const BAR_WIDTH = 30000000;

const entriesColor = '#056ED5';
const entriesPrenColor = '#b7c9e8';
const todayColor = '#F8A1A1';
const DEFAULT_SERIES_COLORS = [entriesColor, entriesPrenColor, todayColor];
const NOPRENOT_SERIES_COLORS = [entriesColor, todayColor];

/** @ngInject */
export class ValueSeriesController extends CommonViewController {
    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies);

        this.$scope.flotService = new FlotService(arsMainDependencies.document, userService, this.state);
        this.supportedReports = [REPORT_TYPE.MT940_STATEMENTS, REPORT_TYPE.PDF_STATEMENTS_COMBINED, REPORT_TYPE.PDF_STATEMENTS_SEPARATED,
            REPORT_TYPE.XLS_TRANSACTION_REPORT, REPORT_TYPE.CSV_TRANSACTION_REPORT,
            REPORT_TYPE.MT942_INTRADAYS, REPORT_TYPE.PDF_INTRADAYS, REPORT_TYPE.XLS_TRANSACTION_INTRADAY_REPORT, REPORT_TYPE.CSV_TRANSACTION_INTRADAY_REPORT];
        this.supportedExports = [EXPORT_TYPE.CSV, EXPORT_TYPE.XLSX];
        this.userService = userService;
        this.backendService = new BackendService(userService, VALUE_SERIES);
        this.DEFAULT_DAYS = 10;
        this.RANGE_LIMIT = 60;
        const endDate = moment();
        endDate.add(this.DEFAULT_DAYS, 'days');

        this.dateFilter = { kind: 'composite', amountRange: { lowerBound: null, upperBound: null, kind: 'amountRange'},
            dateRange: {lowerBound: moment(), upperBound: endDate, kind: 'dateRange'}
        };
        this.minDate =  this.todayPlus(-this.RANGE_LIMIT); // a month backwards
        this.maxDate = this.todayPlus(365); // one year
        this.sessionPersistance.setTime(this.dateFilter.dateRange.upperBound, this.dateFilter.dateRange.lowerBound);
        this.currencyService = new CurrencyService(this.ftsMainDependencies);

        if (this.sessionPersistance.promise) {
            this.loadTabItems(this.$scope);
        } else {
            this.ftsMainDependencies.initCompletedPromise.then(() => this.sessionPersistance.promise.then(() =>
                this.loadTabItems(this.$scope)));
        }

        this.types = [
            { label: this.translate.instant('ENTRIES_MD'), value: false },
            { label: this.translate.instant('ENTRIES_PRENOTATION'), value: true }
        ];
        this.selectedType = true;

        const from = this.todayAtHour(1);
        from.setMinutes(0);
        const to = this.todayAtHour(1);
        to.setMinutes(20);
        const markings = [ { xaxis: { from: from, to: to}, color: todayColor } ];

        this.barChartOptions = ChartUtil.getBarChartDetailOptions(AXIS_DEFAULT_COLOR, BAR_WIDTH, DEFAULT_SERIES_COLORS, markings);
        this.lineChartOptions = ChartUtil.getLineChartDetailOptions(AXIS_DEFAULT_COLOR, DEFAULT_SERIES_COLORS, markings);

        this.userService.promise.then(()=> {
             this.configure(this.lineChartOptions, this.userService.filterFormatter);
             this.configure(this.barChartOptions, this.userService.filterFormatter);
         });

        this.formatXAxis();

        $scope.tabs = [
            { id: TAB_OVERVIEW, label: 'UNGROUPED', state: VALUESERIES_ROUTE },
            { id: TAB_CURRENCY, label: 'BY_CURRENCY', state: VALUESERIES_ROUTE },
            { id: TAB_COUNTRY, label: 'BY_COUNTRY',  state: VALUESERIES_ROUTE },
            { id: TAB_BANK, label: 'BY_BANK', state: VALUESERIES_ROUTE },
            { id: TAB_GROUP, label: 'BY_OWN_GROUP', state: VALUESERIES_ROUTE },
            { id: TAB_ACCOUNT, label: 'BY_ACCOUNTS', state: VALUESERIES_ROUTE }
        ];

        this.$scope.groupData = 'overview';

        this.selectorData = [];
        $scope.$on('groupData.selectorData', (a, data) => this.selectorData = data);

        // functionality only on by Accounts
        $scope.$on('valueSeriesGraphFilter.change', (a, items) => {
            this.backendService.service.config.params.filter = { loadKey: items };
            this.getGraphData();
        });
    }

    $onInit() {
        this.mainCurrenciesPromise = this.currencyService.getCurrencies().then(data => {
            this.mainCurrencies = data;
        });
    }

    loadTabItems() {
        this.sessionPersistance.promise.then(() => {
            this.$scope.consolidationCurrency = this.sessionPersistance.get(CONSOLIDATION_CURRENCY) || DEF_CURRENCY;
            this.ftsMainDependencies.$rootScope.consolidationCurrency = this.$scope.consolidationCurrency.code;
            this.getGraphData();
        });
    }

    selectGroup(group) {
        this.$scope.selectedGroup = group;
        this.backendService.service.config.params.filter = group === 'SELECT_ALL_GLOBAL' ?
            null : { [[this.$scope.groupData]]: [group] };
        this.getGraphData();
    }

    groupBy(groupData) {
        this.$scope.groupData = groupData;
        this.selectGroup('SELECT_ALL_GLOBAL');

        if (groupData !== 'overview') {
            this.$scope.$broadcast('groupData.change', groupData);
        } else {
            this.selectorData = [];
        }
    }

    configure(options, $filter) {
        options.legend = {
            show: true,
            noColumns: 0,
            container:'#legendContainerCurr',
            labelFormatter: function(label) {
                return '<div style="font-size:14px">' + label + '</div>';
            }
        }

        options.yaxis = ChartUtil.getYAxis($filter);
    }

    formatXAxis() {
        const dateRange = this.dateFilter.dateRange;
        const startDate = dateRange.lowerBound.valueOf();
        const endDate = dateRange.upperBound.valueOf();
        const diffDate = moment(endDate).diff(moment(startDate),'days');
        const locale = this.store.get(keyLanguage);
        ChartUtil.formatAxisDisplayWithLimit(diffDate, this.lineChartOptions,[1, "day"],'%d', 11);
        ChartUtil.formatAxisDisplayWithLimit(diffDate, this.barChartOptions,[1, "day"],'%d', 11);

        this.valueSeriesMonths = ChartUtil.getValSeriesMonthTitle(locale, new Date(startDate), new Date(endDate));
        this.backendService.service.config.params['dateFilter'] = this.dateFilter;
        this.$scope.$broadcast('valueSeriesRangeDate.change', this.dateFilter);
    }

    selectConsolidationCurrency(currency) {
        this.ftsMainDependencies.$rootScope.consolidationCurrency = currency.code;
        this.$scope.$broadcast('consolidationCurrency.change', currency);
        this.$scope.consolidationCurrency = currency;
        this.sessionPersistance.set(CONSOLIDATION_CURRENCY, currency);
        this.backendService.service.config.params[CONSOLIDATION_CURRENCY_PARAMS] = currency.code;
        this.getGraphData();
    }

    dateChange() {
        if(this.validateRange()) {
            this.$scope.$broadcast('dateSnapshot.change', this.dateFilter.dateRange);
            this.formatXAxis();
            this.getGraphData();
        }
    }

    validateRange() {
        const dateRange =  this.dateFilter.dateRange;
        const daysDiff = moment(dateRange.upperBound.valueOf()).diff(moment(dateRange.lowerBound.valueOf()),'days');
        // allow same day
        if(daysDiff < 0 ) {
            this.toast.infoPop(this.translate.instant('RANGE_FROM_BEFORE_TO'));
            return false;
        }

		if(daysDiff > this.RANGE_LIMIT) {
            this.toast.infoPop(this.translate.instant('RANGE_DAYS_LIMIT',{ daysLimit: this.RANGE_LIMIT}));
            return false;
        }
        return true;
    }

    typeChange(value) {
        // keep model so there no need to reload data [0] = entries, [1] entries + prenot, [2] today vertical line
        this.valueSeriesChartDataSet = angular.copy(this.valueSeriesChartDataSetModel);
        if (!value) { // remove [2] with prenotations
            this.valueSeriesChartDataSet.splice(1, 1);
            this.barChartOptions.colors = NOPRENOT_SERIES_COLORS;
            this.lineChartOptions.colors = NOPRENOT_SERIES_COLORS;
        } else {
            this.barChartOptions.colors = DEFAULT_SERIES_COLORS;
            this.lineChartOptions.colors = DEFAULT_SERIES_COLORS;
        }

        this.valueSeriesBarChartDataSet = angular.copy(this.valueSeriesBarChartDataSetModel);
    }

    getGraphData() {
        this.ftsMainDependencies.$rootScope.dateFilter = this.dateFilter;
        this.chartPromise = this.backendService.getUserData(VALUES_CHART).then(data => {

            //Bar chart data, entries
            const entries = data.map(value => [ this.toMidnight(value.saldoDate) - BAR_TIME_SHIFT, value.entriesAmount ]);
            const prenotations = data.map(value => [ this.toMidnight(value.saldoDate) + BAR_TIME_SHIFT, value.prenotationAmount ]);
            //Line chart data, values
            const series = data.map(value => [ this.toMidnight(value.saldoDate), value.valueAmount ]);
            const seriesPrenotation = data.map(value => [ this.toMidnight(value.saldoDate), value.valueAmountWithPrenotations ]);

            const fractionDigits = this.$scope.consolidationCurrency.fractionDigits;
            // legend marking no series
            const todayMarker =  { label: this.translate.instant('TODAY'), data: [], fractionDigits: fractionDigits };

            this.valueSeriesChartDataSetModel = [
                { label: this.translate.instant("VALUE_AMNT"), data: series, fractionDigits: fractionDigits },
                { label: this.translate.instant("VALUE_PRENOTATION_AMNT"), data: seriesPrenotation, fractionDigits: fractionDigits },
                todayMarker
            ];

            this.valueSeriesBarChartDataSetModel = [
                { label: this.translate.instant("ENTRIES_AMNT"), data: entries, fractionDigits: fractionDigits },
                { label: this.translate.instant("PRENOTATION_AMNT"), data: prenotations, fractionDigits: fractionDigits },
                todayMarker
            ];

            this.typeChange(this.selectedType);
        });
    }

    toMidnight(value) { // to align the dots vertically with the dates
        return value - (value % 86400000);
    }

    todayPlus(value) {
        const date = new Date();
        date.setDate(date.getDate() + value);
        return date;
    }

    todayAtHour(hours) {
        const date = new Date();
        date.setHours(hours);
        return date;
    }
}
